// extracted by mini-css-extract-plugin
export var editButton = "detailsEvent-module--edit-button--0c6aa";
export var evenement = "detailsEvent-module--evenement--02dd6";
export var eventContent = "detailsEvent-module--event-content--761c9";
export var eventDate = "detailsEvent-module--event-date--e7bd7";
export var eventDateFrom = "detailsEvent-module--event-date-from--ad34d";
export var eventDateTo = "detailsEvent-module--event-date-to--8335c";
export var eventFooter = "detailsEvent-module--event-footer--6d275";
export var eventFooterBack = "detailsEvent-module--event-footer-back--197fe";
export var eventImg = "detailsEvent-module--event-img--cb84d";
export var eventPlace = "detailsEvent-module--event-place--de553";
export var eventPlaceIcon = "detailsEvent-module--event-place-icon--7fe7f";
export var eventPlaceTitle = "detailsEvent-module--event-place-title--45791";
export var eventTaxo = "detailsEvent-module--event-taxo--8901b";
export var eventTitle = "detailsEvent-module--event-title--bb6c7";
export var eventsItemRecurrence = "detailsEvent-module--events-item-recurrence--519e9";
export var pageEvent = "detailsEvent-module--page-event--37237";
export var pageEventAdditionalInfos = "detailsEvent-module--page-event-additional-infos--11f57";